import { render, staticRenderFns } from "./DefaultStep.vue?vue&type=template&id=5f2850bb&scoped=true&"
import script from "./DefaultStep.vue?vue&type=script&lang=js&"
export * from "./DefaultStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2850bb",
  null
  
)

export default component.exports